import { BaseChildState } from './BaseChildState'

export class BaseChildStateWithDelay extends BaseChildState {
    public end = () => {
        setTimeout(() => this._parent.endChild(), 750)
    }
}
